module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue.56d9a4e0.jpg";